import React, { Component } from 'react';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import IntercomChat from 'common/containers/intercom_chat';
import { fetchCategoriesIfNeeded } from 'common/ducks/categories';
import { fetchReviewStatsIfNeeded } from 'marketing/ducks';
import HomeContent from 'marketing/components/home_content';
import { trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME } from 'common/tracking';

export default class Home extends Component {
  componentDidMount() {
    trackMixpanel(MP_VIEWED_MARKETING_PAGE_EVENT_NAME, { "pageName": "Homepage" });
  }

  render() {
    return (
      <div className="l-content" id="content">
        <Meta
          title="Logos, Website, Graphic Design, Product Design, Naming & More"
          meta={[{name: "description", content: "World's most trusted marketplace for graphic design, including logo design, website design, product design and naming your business. 100% money-back guarantee!"}]}
          link={[{ rel: 'canonical', href: getCanonicalURL() }]} />
        <HomeContent />
        <IntercomChat />
      </div>
    );
  }
};

Home.need = [fetchCategoriesIfNeeded, fetchReviewStatsIfNeeded];



// WEBPACK FOOTER //
// ./marketing/components/home.jsx